import LazyComponentWrapper from 'components/lazy-component-wrapper';
import PawLoader from 'components/paw-loader';
import { usePetContext } from 'contexts/pet';
import useRefreshJudgeMe from 'hooks/common/use-refesh-judge-me';
import { useContentful } from 'modules/content-cms/components/context';
import ProductDetailsHeader from 'modules/product-details/components/product-details-header';
import { useProductDetailsHeaderState } from 'modules/product-details/components/product-details-header/state';
import dynamic from 'next/dynamic';
import { FC, useEffect } from 'react';
import { useTrackingStore } from 'stores/tracking';
import { Gtm, gtm } from 'tracking/gtm';
import Container from '../../components/container';
import ContentCmsHeaderContentStatic from '../content-cms/components/header-content';
import BackButton from './components/back-button';
import Content from './components/content';
import ProductDetailsHead from './product-details-head';

const CollectionList = dynamic(() => import('./collection-list'), {
  ssr: false,
  loading: () => (
    <div className={'flex h-24 justify-center'}>
      <PawLoader />
    </div>
  ),
});

const JudgeMeReviews = dynamic(() => import('./components/judge-me-reviews'));

const ProductDetails: FC = () => {
  const { product } = useProductDetailsHeaderState();

  const { current } = usePetContext();
  const { getProductList } = useTrackingStore();

  const { data: contentful } = useContentful();

  useRefreshJudgeMe([contentful.fields.handle]);

  useEffect(() => {
    if (!product) {
      return;
    }

    gtm({
      group: Gtm.GroupName.Product,
      name: Gtm.ProductEventName.Details,
      data: {
        product: {
          productTitle: product.title,
          productId: product.id + '',
          productType: product.productType,
          tags: product.tags.join(','),
          variantId: product.variants[0].id + '',
          // Here, 'PDP' is set as the default list in case the user arrives at the PDP directly using a link,
          // without going through a CDP or other point where the list is registered.
          list: getProductList(product.id, 'PDP'),
          position: 0,
        },
      },
      nonInteractive: true,
    });
    // passing id only as dependency to prevent double event fire (tags could cause rerender)
  }, [product.id]);

  return (
    <>
      <ProductDetailsHead product={product} />

      <BackButton />
      <ProductDetailsHeader />

      <Container>
        <ContentCmsHeaderContentStatic />
      </Container>
      <Content product={product} />

      <JudgeMeReviews product={product} />

      {current && (
        <LazyComponentWrapper>
          <CollectionList petType={current === 'dogs' ? 'dog' : 'cat'} />
        </LazyComponentWrapper>
      )}
    </>
  );
};

export default ProductDetails;
